<template>
  <div class="app-container">
    <div class="title">院校信息</div>
    <div class="box">
      <div class="filter-container">
        <el-input placeholder="院校名称" v-model="name" @keyup.enter.native="getSchools" style="width: 200px;font-size:14px" class="filter-item ipt"></el-input>
        <template>
          <el-select v-model="address" placeholder="院校所在地" @change="getSchools" class="ipt">
            <el-option v-for="item in options01" :key="item.address" :label="item.label" :value="item.address">
            </el-option>
          </el-select>
        </template>
        <template>
          <el-select v-model="type" placeholder="院校层次" @change="getSchools" class="ipt">
            <el-option v-for="item in options02" :key="item.type" :label="item.label" :value="item.type">
            </el-option>
          </el-select>
        </template>
        <el-button @click="getSchools()" class="dalfBut">查询</el-button>
      </div>

      <el-table size="small" current-row-key="id" :data="dataList" strip highlight-current-row :row-style="{height: '60px'}">
        <!-- <el-table-column prop="id" align="center" label="序号"></el-table-column> -->
        <el-table-column label="院校名称" align="center">
          <template slot-scope="scope">
            <!-- <a :href="'#/schoolBrief/' + scope.row.name" target="_blank" >{{scope.row.name}}</a> -->
            <router-link :to="{path:'/configuration/schoolInfo',query:{schoolName: scope.row.name}}" target="_blank">{{scope.row.name}}</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="院校所在地" align="center"></el-table-column>
        <el-table-column prop="department" label="教育行政主管部门" align="center"></el-table-column>
        <el-table-column prop="type" label="院校类型" align="center"></el-table-column>
        <el-table-column prop="level" label="学历层次" align="center"></el-table-column>
        <el-table-column label="一流大学建设高校" align="center" width="90px">
          <template slot-scope="scope">
            <span v-if="scope.row.topUniversities == 1"><i class="el-icon-check"></i></span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column label="一流学科建设高校" align="center" width="90px">
          <template slot-scope="scope">
            <span v-if="scope.row.topdiscipline == 1"><i class="el-icon-check"></i></span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column label="研究生院" align="center" width="90px">
          <template slot-scope="scope">
            <span v-if="scope.row.graduateSchool == 1"><i class="el-icon-check"></i></span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="院校满意度" align="center"></el-table-column>
      </el-table>

      <!--分页组件-->
      <div class="pagination-container" align="right">
        <el-pagination class="pagiantion" @current-change="handleCurrentChange" :current-page="pagination.currentPage" :page-size="pagination.pageSize" layout="total, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>

    </div>
  </div>
</template>
<script>
import school from '../../api/configuration'
export default {
  name: 'school',
  data() {
    return {
      dataList: [], //当前页要展示的列表数据
      // 分页设置
      pagination: {
        //分页相关模型数据
        currentPage: 1, //当前页码
        pageSize: 20, //每页显示的记录数
        total: 0 //总记录数
      },
      name: '',
      address: '',
      type: '',
      options01: [],
      options02: []
    }
  },
  methods: {
    // 获取所有学校
    getSchools() {
      let params = {
        current: this.pagination.currentPage,
        size: this.pagination.pageSize,
        name: this.name,
        address: this.address,
        type: this.type
      }
      school.getSchools(params).then(res => {
        this.dataList = res.list
        this.pagination.total = res.total
      })
    },
    // 获取所有省份
    getProvinces() {
      school.getProvinces().then(res => {
        for (let i in res.provinces) {
          var obj = {
            address: res.provinces[i],
            label: res.provinces[i]
          }
          this.options01.push(obj)
        }
      })
    },
    // 获取所有学校类型
    getSchoolTypes() {
      school.getSchoolTypes().then(res => {
        for (let i in res.schoolTypes) {
          var obj = {
            type: res.schoolTypes[i],
            label: res.schoolTypes[i]
          }
          this.options02.push(obj)
        }
      })
    },
    //切换页码
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.getSchools()
    }
  },
  created() {
    this.getSchools()
    this.getProvinces()
    this.getSchoolTypes()
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-size: 16px;
}
.app-container {
  height: 100vh;
  overflow: auto;
}
.box {
  width: 80%;
  margin: auto;
}
.box h1 {
  font-size: 30px;
  font-weight: 300;
  margin-bottom: 10px;
}

.filter-container {
  padding: 10px 0;
}

.filter-container .ipt {
  margin-right: 5px;
  vertical-align: middle;
}
.filter-container .dalfBut {
  width: 70px;
  height: 40px;
  border-radius: 4px;
  background-color: #66b1ff;
  color: #fff;
}
a {
  color: #606266;
}
a:hover {
  color: #1cb278;
  text-decoration: underline;
}
.pagination-container {
  margin-top: 5px;
}
.el-table__body tr:hover {
  background-color: red !important;
}
.title {
  width: 100%;
  height: 80px;
  background-image: url(../../assets/img/school-search.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 -100px;
  text-align: center;
  line-height: 80px;
  font-size: 32px;
  color: #fff;
  letter-spacing: 20px;
  opacity: 0.8;
}
</style>